import React from 'react';
import { IconButton, Portal } from '@mui/material';
import { Close } from '@mui/icons-material';
import { PropTypes } from 'prop-types';

import '../common.scss';
import './VerticalPanel.scss';

export default function SettingsPanel({ container, close }) {
  return (
    <Portal container={container.current}>
      <div className="settings vertical-panel">
        <div className="header">
          <h3>Chart Options</h3>
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </div>

        <div className="content">Example chart settings</div>
      </div>
    </Portal>
  );
}

SettingsPanel.propTypes = {
  container: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
};
